class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 100);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    // document.getElementById('AjaxinateContainer').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    tm_get_review_badge();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    // Used to snapshot $('.delievery_txt_wrp').html() before this replace and
    // paste it back after. jQuery's no-arg .html() getter only reads the
    // FIRST matched element, but the setter applies that one string to every
    // matched element - so every product card's delivery-countdown widget
    // was overwritten with a frozen copy of the first card's widget,
    // including whatever hidden/visibility inline style it happened to have
    // at that instant. That's what caused the delivery widget to look
    // permanently stuck (or re-flash) after any filter/sort/search action -
    // removing it lets each card's own widget re-populate from the C-EDD
    // app normally, the same way it does on a fresh page load.
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    console.log("rendered succesfully")
    // Vat price render js starts from here
    function ChangePriceFacet(){
      var VatPersantage = 0;
      var VatText = 'ex. VAT';
      if($(".tm_pricing_switch input[type='checkbox']").is(':checked')){
        VatPersantage = Number($(".tm_pricing_switch input[type='checkbox']").val());
        VatText = 'inc. VAT';
      }
      if($("body").hasClass("collection") || $("body").hasClass("search")){
        $(".tm_colle-price-wrapper").each(function(){
          var CurrentPrice = Number($(this).attr('data-price'));
          var persatage = VatPersantage / 100;
          var incrasePrice = CurrentPrice*persatage;
          var FinalInVat = CurrentPrice + incrasePrice;
          var InVATPrice = FinalInVat.toFixed(2);
          $(this).attr("data-Vat",InVATPrice);
          console.log()
          $(this).find(".main_price").html(InVATPrice.split('.')[0]);
          $(this).find(".tm_price_sm").html(InVATPrice.split('.')[1]);
          $(this).find(".tm_ex_VAt").html(VatText);
        })
        console.log("collection template")
      }
    }
    ChangePriceFacet();
    $('.facet-filters__sort').each(function(){
       var text = $(this).find('option:selected').text()
      var $aux = $('<span/>').append($('<span/>').text(text))
      $(this).after($aux)
      $(this).width($aux.width())
      console.log("select width",$aux.width())
      $aux.remove()
    })
    if(window.innerWidth < 750){
      var text = $("#SortBy-mobile").find('option:selected').text()
      var $aux = $('<span/>').append($('<span/>').text(text))
      $("#SortBy-mobile").after($aux)
      $("#SortBy-mobile").width($aux.width())
      $aux.remove()
    }
    // Ajaxinate (assets/ajaxinate.min.js) only defines the global `Ajaxinate`
    // constructor inside its own `if ($(window).width() < 992)` guard - a
    // deliberate mobile/tablet-only infinite-scroll setup. On desktop that
    // leaves the hoisted `var Ajaxinate` as undefined, so `new Ajaxinate()`
    // here threw "Ajaxinate is not a constructor" on every single filter/sort
    // on desktop - confirmed live via the console error, present on every
    // AJAX re-render. Since this was uncaught, it also aborted the REST of
    // this function, which is why matchHeight() on the next line never ran
    // after a desktop sort/filter: product cards kept whatever height they
    // had from the page's initial load, each row free to mismatch the next
    // once the (re-sorted) content no longer matched what that row's height
    // was originally sized for. Guarding this one line, rather than touching
    // ajaxinate.min.js's own conditional, keeps the mobile-only behaviour
    // exactly as designed and just stops its absence from taking everything
    // after it down with it.
    var endlessScroll = typeof Ajaxinate === 'function' ? new Ajaxinate() : null;
    $('.tm_collection-info').matchHeight();
    // ends
  }

  static renderProductCount(html) {
    if(new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')){
      var count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    }else{
      var count = "";
    }
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if(container){
       container.innerHTML = count;
      setTimeout(function(){
        container.classList.remove('loading');
      }, 200);
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      setTimeout(function(){
      containerDesktop.classList.remove('loading');
      }, 200);
    }
    
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
$(document).ready(function(){
  $('.facet-filters__sort').each(function(){
      var text = $(this).find('option:selected').text()
      var $aux = $('<span/>').append($('<span/>').text(text))
      $(this).after($aux)
      $(this).width($aux.width())
      console.log("select width",$aux.width())
      $aux.remove()
    })
  if(window.innerWidth < 750){
    var text = $("#SortBy-mobile").find('option:selected').text();
    var $aux = $('<span/>').append($('<span/>').text(text));
      $("#SortBy-mobile").after($aux)
      $("#SortBy-mobile").width($aux.width())
      $aux.remove()
  }
})